import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
 ChangeDetectionStrategy,
 ChangeDetectorRef,
 Component,
 EventEmitter,
 Inject,
 InjectionToken,
 Input,
 Output,
 PLATFORM_ID,
 inject,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { Router } from '@angular/router';
import { WebEngageRepository } from '@core/services/repositories/webEngage.repository';
import { ComboRooms, RoomInfo } from '@models/room';
import { RialToTomanPipe } from '@shared/pipes/rial-to-toman.pipe';
import { MomentService } from '@core/services/moment.service';
import { WebengageService } from '@core/services/webengage.service';
import { HotelInfoUiService } from '../../services/hotel-info-ui.service';
import { SearchBoxService } from '@shared/services/serach-box.service';
import { WINDOW } from '../../accommodation-info.module';

@Component({
 selector: 'iho-pdp-sidebar-reserve-info',
 standalone: true,
 imports: [CommonModule, MatButtonModule, RialToTomanPipe, RouterModule],
 templateUrl: './pdp-sidebar-reserve-info.component.html',
 styleUrls: ['./pdp-sidebar-reserve-info.component.scss'],
 // changeDetection: ChangeDetectionStrategy.OnPush
})
export class PdpSidebarReserveInfoComponent {
 // webEngageRepo = inject(WebEngageRepository);
 router = inject(Router);
 pdpService = inject(HotelInfoUiService);
 webengageService = inject(WebengageService);
 momentService = inject(MomentService);
 searchBoxService = inject(SearchBoxService);

 selectedRoomsCount = 0;
 disabledBtn = false;

 @Input()
 get dataSource(): Array<RoomInfo & { count: number; id: number; name: string }> {
  return this._dataSource;
 }
 set dataSource(value: Array<RoomInfo & { count: number; id: number; name: string }>) {
  this._dataSource = value;
  this.selectedRoomsCount = this.dataSource.reduce(
   (totalCount, eachRoom) => totalCount + eachRoom.count,
   0
  );
  this.prepareDataForSendingToFollowReservation();
 }
 private _dataSource: Array<RoomInfo & { count: number; id: number; name: string }> = [];

 selectedRooms: any[] = [];
 selectedRoomsJson = '';

 @Input() lowestPrice = 0;

 @Input() totalPrice = 0;
 @Input() totalComboPrice = 0;

 @Input() startDate = '';
 @Input() endDate = '';
 @Input() hotelId = -1;
 @Input() hotelName = '';
 @Input() nights = -1;
 @Input() activeFiltersNames: string[] = [];
 @Input() selectedComboRooms?: ComboRooms[];

 @Output() removeAll = new EventEmitter(false);
 @Output() removeCountForOneRoom = new EventEmitter<number>();
 @Output() removeComboRooms = new EventEmitter(false);

 constructor(
  @Inject(WINDOW) private window: any,
  @Inject(PLATFORM_ID) private platformId: Object
 ) {}

 clearAll() {
  this.removeAll.emit(true);
 }

 emitRemoveComboRooms() {
  this.removeComboRooms.emit(true);
 }

 resetCountForSpecificRoom(roomId: number) {
  this.removeCountForOneRoom.emit(roomId);
 }

 /**
  * @description کار این متد اینه که از اتاق های انتخاب شده، یه دیتای مپ شده میسازه و
  * همون دیتا رو باید به صورت پارامس ارسال بکنیم برای صفحه پیگیری رزرو
  */
 prepareDataForSendingToFollowReservation() {
  this.selectedRooms = [];
  this.dataSource.forEach((item) => {
   const data = {
    id: item.id,
    count: item.count,
    nonRefundable: item.roomDetail.nonRefundable,
   };
   this.selectedRooms.push(data);
  });
  this.selectedRoomsJson = JSON.stringify(this.selectedRooms);
 }

 goToFollowReservation() {
  this.disabledBtn = true;
  const mappedRoomAmenities = this.dataSource.map((room) => {
   if (room.roomDetail.breakfast && room.roomDetail.dinner && room.roomDetail.lunch) {
    return 'full boards';
   } else if (room.roomDetail.breakfast && room.roomDetail.lunch) {
    return 'half boards';
   } else {
    return '';
   }
  });

  const payload = {
   CheckInDate: this.startDate,
   CheckOutDate: this.endDate,
   Destination: this.hotelName,
   Filters: this.activeFiltersNames,
   HotelId: this.hotelId,
   Price: this.totalPrice,
   RoomAmenities: mappedRoomAmenities,
   RoomName: this.dataSource.map((room) => room.name),
   RoomNumber: this.dataSource.length,
  };
  if (isPlatformBrowser(this.platformId)) {
   this.window.dataLayer = this.window.dataLayer || [];
   this.window.dataLayer.push({
    event: 'add_to_cart',
    ecommerce: {
     items: [
      {
       item_name: this.hotelName,
       item_id: this.hotelId,
       price: this.totalPrice,
       item_category: this.router.url.split('/')[1],
       item_variant: this.dataSource.map((room) => room.name),
       quantity: this.nights,
      },
     ],
    },
   });
  }

  // this.webEngageRepo.reserve(payload).subscribe((res) => {
  //  this.disabledBtn = false;
  // });
  this.webengageService.trackIntrack('Room-Select', {
   CheckInDate: this.momentService.toGergorian(this.startDate),
   CheckOutDate: this.momentService.toGergorian(this.endDate),
   Destination: this.pdpService?.hotelInfo()?.HotelHeader.Address.CityName,
   hotelName: this.pdpService?.hotelFullName,
   HotelId: this.hotelId,
   Price: this.totalPrice,
   RoomName: this.dataSource?.map((room) => room.name),
   RoomNumber: this.dataSource?.length,
   numberOfNights: this.pdpService?.nights,
   hotelType: this.pdpService?.hotelInfo()?.HotelHeader?.TypeName,
   hotelRate: +this.pdpService?.hotelInfo()?.HotelHeader?.Score?.ScoreNumber,
   hotelGrade: this.pdpService.hotelInfo()?.HotelHeader?.Star?.GradeId || 0,
   roomCapacity: this.dataSource?.map((room) => room?.reservable),
  });
  let link =
   '/persian/pursuit' +
   ('?hotelId=' + this.hotelId) +
   ('&dateLength=' + this.nights) +
   ('&departing=' + this.startDate) +
   ('&returning=' + this.endDate) +
   ('&selectedRooms=' + this.selectedRoomsJson);

  const _payload = {
   hotelId: this.pdpService.hotelId,
   arrivalDate: this.startDate,
   checkoutDate: this.endDate,
   rooms: this.pdpService.selectedRooms().map((room) => ({
    id: room.id,
    quantity: room.count,
    nonRefundable: room.roomDetail.nonRefundable,
    index: 0,
   })),
   IsWaitingList: false,
   organizationId: null,
   comboRooms: this.pdpService.selectedComboRooms().length
    ? this.pdpService.selectedComboRooms()[0].combenationId
    : null,
   AccommodationType: this.searchBoxService.accommodation() == 'ecolodge' ? 2 : 1,
  };

  this.pdpService.getReserveUUID(_payload).subscribe((uuid) => {
   if (uuid) {
    window.location.href = window.location.origin + '/persian/pursuit/' + uuid;
   }
  });

  //   if (this.pdpService.selectedComboRooms().length)
  //    link = link + '&comboRooms=' + this.pdpService.selectedComboRooms()[0].combenationId;

  //   location.href = location.origin + link;
 }
}
